import { useRecordContext, useGetList, Loading, useTranslate, useLocaleState } from 'react-admin';
import { Box, Card, CardContent, Typography, Divider } from '@mui/material';
import { ZapyInstanceManager } from '../../../../components/channel';
import type { Channel, ChannelConnection } from '../../../../types/chat.types';

export const ZapyChannelShow = () => {
  const record = useRecordContext<Channel>();
  const translate = useTranslate();
  const [locale] = useLocaleState();

  const { data: connections, isLoading } = useGetList<ChannelConnection>(
    'channel-connection',
    {
      filter: { channelId_eq: record?.id },
      pagination: { page: 1, perPage: 50 },
      sort: { field: 'createdAt', order: 'DESC' },
    },
    { enabled: !!record?.id }
  );

  if (!record) return null;

  return (
    <Box display="flex" flexDirection="column" gap={3}>
      {/* WhatsApp Connection Manager */}
      {isLoading ? (
        <Loading />
      ) : connections?.length ? (
        connections.map((connection) => (
          <ZapyInstanceManager
            key={connection.id}
            channelConnectionId={+connection.id}
            channelConnectionName={connection.displayName || connection.identifier}
          />
        ))
      ) : (
        <Card variant="outlined">
          <CardContent>
            <Typography color="textSecondary">
              {translate('resources.channel.zapy.noConnections')}
            </Typography>
          </CardContent>
        </Card>
      )}

      {/* Channel Details */}
      <Card variant="outlined">
        <CardContent>
          <Typography variant="subtitle2" color="textSecondary" gutterBottom>
            {translate('resources.channel.tabs.details')}
          </Typography>
          <Divider sx={{ my: 1 }} />

          <Box display="grid" gridTemplateColumns="1fr 1fr" gap={2}>
            <Box>
              <Typography variant="caption" color="textSecondary">
                UUID
              </Typography>
              <Typography variant="body2">{record.uuid}</Typography>
            </Box>

            <Box>
              <Typography variant="caption" color="textSecondary">
                {translate('resources.channel.fields.type')}
              </Typography>
              <Typography variant="body2">
                {translate(`resources.channel.types.${record.type}`)}
              </Typography>
            </Box>

            <Box>
              <Typography variant="caption" color="textSecondary">
                {translate('resources.channel.fields.createdAt')}
              </Typography>
              <Typography variant="body2">
                {new Date(record.createdAt).toLocaleString(locale)}
              </Typography>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};
